<template>
  <div class="middle-bottom">
    <a-card>
      <div class="body">
        <a-card-grid @click="show_img(item)" class="item" v-for="(item, index) in list" :key="index">
          <div class="icon">
            <img v-if="item.state == -1" src="../../assets/xuhui/person-none.png" />
            <img v-else src="../../assets/xuhui/person.png" />
            <div class="number">{{ item.position }}号岗</div>
          </div>
          <div class="info">
            <div class="member">
              {{ item.guard.name || '暂无数据' }}
              <img class="card" v-if="item.state != -1" src="../../assets/xuhui/card.png" />
            </div>
            <div class="type" v-if="item.guard.id == 0">非本馆在册救生员</div>
            <div class="type"></div>
            <div class="t-info">
              <div class="t-item">
                <div class="label">时长：</div>
                <div class="val" v-if="item.state == -1">- - | 无人</div>
                <div class="val" v-else :class="item.duration_secs <= 3600 ? '' : 'warning'">
                  {{ item.minute }} | {{ item.duration_secs <= 3600 ? '良好' : '超时' }}
                </div>
              </div>
              <div class="t-item">
                <div class="label">状态：</div>
                <div class="val" :class="item.class">{{ item.state_info }}</div>
              </div>
            </div>
          </div>
        </a-card-grid>
      </div>
    </a-card>
    <a-modal v-model="visible" :width="800" title="岗位查看" :footer="null">
      <div class="img-area">
        <img :src="current_src" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

let timer = null

export default {
  data() {
    return {
      list: [],
      visible: false,
      current_src: '',
    }
  },
  computed: {
    ...mapState({
      sid: (state) => state.user.sid,
    }),
  },
  destroyed() {
    clearInterval(timer)
  },
  mounted() {
    this.get_data()

    timer = setInterval(() => {
      this.get_data()
    }, 10000)
  },
  methods: {
    show_img(row) {
      // if (row.state == -1) return
      this.current_src = ''
      if (process.env.NODE_ENV == 'development') {
        this.current_src = row.image_url
      } else {
        this.current_src = row.image_url
      }
      this.$nextTick(() => {
        this.visible = true
      })
    },
    get_data() {
      this.$http({
        url: 'api/guards-onduty',
        method: 'get',
        data: {
          sid: this.sid,
        },
      }).then((r) => {
        r.data.forEach((row) => {
          row.minute = Math.floor(row.duration_secs / 60) + '分钟'

          if (row.state == -1) {
            row.state_info = '无人'
            row.class = 'none'
          } else if (row.state == 0) {
            row.state_info = '状态不佳'
            row.class = 'warning'
          } else if (row.state == 1) {
            row.state_info = '良好'
            row.class = ''
          }
        })
        this.list = r.data
      })
    },
  },
}
</script>

<style lang="less" scoped>
.img-area {
  width: 100%;
  img {
    width: 100%;
  }
}
/deep/ .ant-card-body {
  padding: 0;
  .body {
    overflow: auto;
    height: 240px;
  }
}
.middle-bottom {
  color: #fff;
  padding: 0 30px;
  margin-top: 18px;
  .item {
    display: flex;
    align-items: flex-start;
    width: 50%;
    .icon {
      width: 50px;
      margin-right: 24px;
      img {
        width: 100%;
        height: 62px;
      }
      .number {
        width: 100%;
        // background: #32c5ff;
        border-radius: 2px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin-top: -20px;
      }
    }
    .info {
      .member {
        font-weight: 500;
        color: #fff;
        font-size: 16px;
        display: flex;
        align-items: center;
        .card {
          width: 18px;
          height: 18px;
          margin-left: 10px;
        }
      }
      .type {
        color: rgba(255, 255, 255, 0.65);
        font-size: 12px;
      }
      .t-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .t-item {
          display: flex;
          align-items: center;
          &:first-of-type {
            margin-right: 22px;
          }
          .label {
            font-size: 12px;
          }
          .val {
            color: #32c5ff;
            &.warning {
              color: #e02020;
            }
            &.none {
              color: rgba(255, 255, 255, 0.65);
            }
          }
        }
      }
    }
  }
  /deep/ .ant-card {
    background-color: transparent;
    color: #fff;
    &.ant-card-bordered {
      border: none;
    }
    .ant-card-grid {
      box-shadow: 0 0 0 0 #447092;
      padding: 5px 20px;
      cursor: pointer;
      &:hover {
        box-shadow: 0 0.1vw 0.42vw rgba(81, 209, 248, 0.8);
      }
    }
  }
}
</style>
